module.exports = __webpack_public_path__ + "img/Events-News CTSP regional.66b06a71.jpg";